import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = {
  key: 0,
  style: {"margin-bottom":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h3", null, _toDisplayString(_ctx.nodeName ? 'Suggest an Improvement' : 'Make a Suggestion'), 1),
      (_ctx.nodeName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createTextVNode("For ", -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.nodeName), 1)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.text) = $event)),
        style: {"height":"220px"}
      }, null, 512), [
        [_vModelText, _ctx.formData.text]
      ]),
      _createElementVNode("input", {
        class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
        type: "submit",
        value: "Submit",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit()))
      }, null, 2)
    ])
  ]))
}